
import React from "react";
import { Button } from "@/components/ui/button";
import { Camera, ImagePlus, Images, Wand } from "lucide-react";

interface ImageCaptureActionsProps {
  onUploadClick: () => void;
  onCameraClick: () => void;
  onGalleryClick: () => void;
  capturedImage?: string | null;
  onGenerateIdeas?: () => void;
  isGenerating?: boolean;
  userCredits?: any;
  isImageConfirmed?: boolean;
}

export function ImageCaptureActions({ 
  onUploadClick, 
  onCameraClick, 
  onGalleryClick,
  capturedImage,
  onGenerateIdeas,
  isGenerating = false,
  userCredits,
  isImageConfirmed = false
}: ImageCaptureActionsProps) {
  // If we have a captured image that's been confirmed, show AI generation as primary action
  if (capturedImage && onGenerateIdeas && isImageConfirmed) {
    return (
      <div className="fixed bottom-4 left-4 right-4 z-50">
        <div className="glass-card rounded-2xl p-4 max-w-md mx-auto">
          <Button
            onClick={onGenerateIdeas}
            disabled={isGenerating}
            className="w-full py-6 text-lg flex items-center justify-center gap-3"
          >
            <Wand size={24} className={isGenerating ? "animate-spin" : ""} />
            <span>
              {isGenerating
                ? "Generating Ideas..."
                : "Generate Creative Ideas with AI"}
            </span>
          </Button>

          {userCredits && (
            <p className="mt-2 text-sm text-muted-foreground text-center">
              Credits remaining: {userCredits.credits_balance} / {userCredits.credits_balance + userCredits.credits_used}
            </p>
          )}
        </div>
      </div>
    );
  }

  // Default state - show capture/upload options
  return (
    <div className="fixed bottom-4 left-4 right-4 z-50">
      <div className="glass-card rounded-2xl p-4 max-w-md mx-auto">
        <div className="flex justify-center space-x-3">
          <Button 
            variant="outline" 
            onClick={onUploadClick}
            className="flex gap-2 items-center flex-1"
          >
            <ImagePlus size={18} />
            <span className="hidden sm:inline">Upload</span>
          </Button>
          
          <Button 
            variant="default" 
            onClick={onCameraClick}
            className="flex gap-2 items-center flex-1"
          >
            <Camera size={18} />
            <span className="hidden sm:inline">Take Photo</span>
          </Button>
          
          <Button 
            variant="secondary" 
            onClick={onGalleryClick}
            className="flex gap-2 items-center flex-1"
          >
            <Images size={18} />
            <span className="hidden sm:inline">Gallery</span>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ImageCaptureActions;
